export default __webpack_public_path__ + "static/media/SavingsIncrease.b15086a8.svg";